document.addEventListener('DOMContentLoaded', function () {

  /* ---------- post-purchase redirect handler ---------- */
  (function checkPostPurchaseRedirect() {
    try {
      var params = new URLSearchParams(window.location.search);
      var hasOrderParam = params.has('order_completed') || params.has('checkout_completed') || params.has('thank_you') || (params.has('order_id') && !window.location.pathname.includes('order-confirmation'));
      if (hasOrderParam && !window.location.pathname.includes('order-confirmation') && !window.location.pathname.includes('thank-you')) {
        window.location.href = '/pages/order-confirmation?' + params.toString();
        return;
      }
    } catch (e) {}
  })();

  /* ---------- mobile nav ---------- */
  var mobileNav = document.getElementById('mobileNav');
  var menuToggle = document.getElementById('menuToggle');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.hidden;
      mobileNav.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- cart count badge (works across every page) ---------- */
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var count = 0;
      if (cart.items && cart.items.length) {
        cart.items.forEach(function (item) {
          if (item.handle !== 'insured-shipping-protection') {
            count += item.quantity;
          }
        });
      } else {
        count = cart.item_count || 0;
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.setAttribute('data-count', count);
        el.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
      });
    }).catch(function () { /* non-fatal */ });
  }
  refreshCartCount();

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var open = item.getAttribute('data-open') === 'true';
      item.parentElement.querySelectorAll('.faq-item').forEach(function (i) {
        i.setAttribute('data-open', 'false');
        var a = i.querySelector('.faq-a');
        if (a) a.hidden = true;
      });
      if (!open) {
        item.setAttribute('data-open', 'true');
        var a = item.querySelector('.faq-a');
        if (a) a.hidden = false;
      }
    });
  });
  document.querySelectorAll('.faq-a').forEach(function (a) { a.hidden = true; });

  /* ---------- product gallery & fullscreen lightbox ---------- */
  var galleryContainer = document.querySelector('[data-gallery]');
  var stageItems = document.querySelectorAll('.gallery-stage-item');
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  var zoomBtn = document.querySelector('[data-gallery-zoom]');
  var lightbox = document.getElementById('productLightbox');
  var lightboxSlides = document.querySelectorAll('.tp-lightbox__slide');
  var lightboxThumbs = document.querySelectorAll('.tp-lightbox__thumb');
  var lightboxCurr = document.querySelector('[data-lightbox-curr]');
  var totalMedia = stageItems.length || 1;
  var currentMediaIndex = 0;

  function setActiveMedia(index) {
    if (index < 0) index = totalMedia - 1;
    if (index >= totalMedia) index = 0;
    currentMediaIndex = index;

    // Pause all stage videos
    stageItems.forEach(function (item) {
      var vid = item.querySelector('video');
      if (vid && !vid.paused) { vid.pause(); }
      item.style.display = 'none';
      item.classList.remove('active');
    });

    if (stageItems[index]) {
      stageItems[index].style.display = 'block';
      stageItems[index].classList.add('active');
    }

    galleryThumbs.forEach(function (thumb, idx) {
      if (idx === index) {
        thumb.classList.add('active');
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        thumb.classList.remove('active');
      }
    });
  }

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.getAttribute('data-index') || '0', 10);
      if (idx === currentMediaIndex && thumb.getAttribute('data-media-type') !== 'video') {
        openLightbox(idx);
      } else {
        setActiveMedia(idx);
      }
    });
  });

  // Clicking main stage image opens lightbox
  var mainContainer = document.querySelector('[data-gallery-main-container]');
  if (mainContainer) {
    mainContainer.addEventListener('click', function (e) {
      // If clicking video controls, let standard controls handle it
      if (e.target.tagName === 'VIDEO' || e.target.closest('video')) return;
      openLightbox(currentMediaIndex);
    });
  }

  if (zoomBtn) {
    zoomBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      openLightbox(currentMediaIndex);
    });
  }

  function setLightboxSlide(index) {
    if (index < 0) index = totalMedia - 1;
    if (index >= totalMedia) index = 0;
    currentMediaIndex = index;

    // Pause lightbox videos
    lightboxSlides.forEach(function (slide) {
      var vid = slide.querySelector('video');
      if (vid && !vid.paused) vid.pause();
      slide.style.display = 'none';
      slide.classList.remove('active');
    });

    if (lightboxSlides[index]) {
      lightboxSlides[index].style.display = 'flex';
      lightboxSlides[index].classList.add('active');
      var activeVid = lightboxSlides[index].querySelector('video');
      if (activeVid) {
        activeVid.play().catch(function() {});
      }
    }

    lightboxThumbs.forEach(function (thumb, idx) {
      if (idx === index) {
        thumb.classList.add('active');
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        thumb.classList.remove('active');
      }
    });

    if (lightboxCurr) {
      lightboxCurr.textContent = index + 1;
    }

    // Sync in-page stage as well
    setActiveMedia(index);
  }

  function openLightbox(index) {
    if (!lightbox) return;
    lightbox.hidden = false;
    document.body.classList.add('tp-lightbox-open');
    setLightboxSlide(typeof index === 'number' ? index : currentMediaIndex);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightboxSlides.forEach(function (slide) {
      var vid = slide.querySelector('video');
      if (vid && !vid.paused) vid.pause();
    });
    lightbox.hidden = true;
    document.body.classList.remove('tp-lightbox-open');
  }

  if (lightbox) {
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setLightboxSlide(currentMediaIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setLightboxSlide(currentMediaIndex + 1);
      });
    }

    lightboxThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-lightbox-thumb') || '0', 10);
        setLightboxSlide(idx);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') setLightboxSlide(currentMediaIndex - 1);
      if (e.key === 'ArrowRight') setLightboxSlide(currentMediaIndex + 1);
    });

    // Touch swipe support in lightbox
    var touchStartX = 0;
    var touchEndX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchEndX - touchStartX;
      if (Math.abs(diff) > 45) {
        if (diff < 0) {
          setLightboxSlide(currentMediaIndex + 1);
        } else {
          setLightboxSlide(currentMediaIndex - 1);
        }
      }
    }, { passive: true });
  }

  /* ---------- product form: variant selection, quantity, add-to-cart ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
    var variantsJson = formEl.getAttribute('data-variants');
    var variants = [];
    try { variants = JSON.parse(variantsJson); } catch (e) { variants = []; }

    var idInput = formEl.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price-display]');
    var compareEl = document.querySelector('[data-compare-display]');
    var saveEl = document.querySelector('[data-save-display]');
    var addBtn = formEl.querySelector('[data-add-to-cart]');
    var statusEl = formEl.querySelector('[data-form-status]');
    var qtyInput = formEl.querySelector('[data-qty-input]');

    var selected = {};
    formEl.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var pressed = group.querySelector('.swatch[aria-pressed="true"]');
      if (pressed) selected[idx] = pressed.getAttribute('data-value');
    });

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (idx) { return v['option' + idx] === selected[idx]; });
      });
    }

    function updateUI() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = moneyFormat(v.price) + ' AUD';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (compareEl) { compareEl.textContent = moneyFormat(v.compare_at_price); compareEl.hidden = false; }
        if (saveEl) {
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.hidden = false;
        }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
      var isSoldOut = formEl.hasAttribute('data-sold-out') || !v.available;
      if (addBtn) {
        addBtn.disabled = isSoldOut;
        addBtn.textContent = isSoldOut ? 'Sold out' : ('Add to cart — ' + moneyFormat(v.price));
      }
      function updateTierDisplay(v) {
        var tier1Price = formEl.querySelector('[data-tier-price="1"]');
        var tier2Price = formEl.querySelector('[data-tier-price="2"]');
        var tier3Price = formEl.querySelector('[data-tier-price="3"]');
        var t1Cents = v.price;
        var t2Cents = Math.round(v.price * 2 * 0.85);
        var t3Cents = Math.round(v.price * 3 * 0.80);

        if (tier1Price) tier1Price.textContent = moneyFormat(t1Cents);
        if (tier2Price) tier2Price.textContent = moneyFormat(t2Cents);
        if (tier3Price) tier3Price.textContent = moneyFormat(t3Cents);

        var tier1Desc = formEl.querySelector('[data-tier-desc="1"]');
        if (tier1Desc) {
          if (t1Cents >= 8000) {
            tier1Desc.textContent = 'Includes Both Free Care Gifts ($139+ Value · Limit 1 each) & AU Delivery';
          } else if (t1Cents >= 2999) {
            tier1Desc.textContent = 'Includes Free Grooming Glove ($39.99 Value · Limit 1)';
          } else {
            tier1Desc.textContent = 'Standard single unit · Free AU Delivery';
          }
        }

        var tier2Desc = formEl.querySelector('[data-tier-desc="2"]');
        if (tier2Desc) {
          if (t2Cents >= 8000) {
            tier2Desc.textContent = 'Includes Free Bath Mat ($99.99), Glove & Free AU Delivery · Limit 1 each';
          } else {
            tier2Desc.textContent = 'Includes Free Grooming Glove ($39.99) & Free AU Delivery · Limit 1';
          }
        }

        var currentQty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
        var effectiveSubtotal;
        if (currentQty === 2) {
          effectiveSubtotal = t2Cents;
        } else if (currentQty >= 3) {
          effectiveSubtotal = Math.round(v.price * currentQty * 0.80);
        } else {
          effectiveSubtotal = v.price * currentQty;
        }

        if (addBtn && !isSoldOut) {
          if (currentQty === 2) {
            addBtn.textContent = 'Add 2 to cart — ' + moneyFormat(t2Cents) + ' (Save 15%)';
          } else if (currentQty >= 3) {
            addBtn.textContent = 'Add ' + currentQty + ' to cart — ' + moneyFormat(effectiveSubtotal) + ' (Save 20% · Best Value)';
          } else {
            addBtn.textContent = 'Add to cart — ' + moneyFormat(v.price);
          }
        }

        var subtotalEl = formEl.querySelector('[data-gift-progress-subtotal]');
        if (subtotalEl) {
          subtotalEl.textContent = moneyFormat(effectiveSubtotal) + ' Subtotal';
        }

        var fillEl = formEl.querySelector('[data-gift-progress-fill]');
        if (fillEl) {
          var pct = Math.min(100, Math.round((effectiveSubtotal / 8000) * 100));
          fillEl.style.width = pct + '%';
        }

        var stopGlove = formEl.querySelector('[data-gift-stop="2999"]') || formEl.querySelector('[data-gift-stop="3000"]');
        if (stopGlove) {
          if (effectiveSubtotal >= 2999) stopGlove.classList.add('reached');
          else stopGlove.classList.remove('reached');
        }

        var stop80 = formEl.querySelector('[data-gift-stop="8000"]');
        if (stop80) {
          if (effectiveSubtotal >= 8000) stop80.classList.add('reached');
          else stop80.classList.remove('reached');
        }

        var gloveCard = formEl.querySelector('[data-gift-card="glove"]');
        var gloveBadge = formEl.querySelector('[data-gift-badge="glove"]');
        if (gloveCard && gloveBadge) {
          if (effectiveSubtotal >= 2999) {
            gloveCard.classList.add('is-unlocked');
            gloveBadge.innerHTML = '<span class="gift-badge-unlocked"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"/></svg> UNLOCKED &middot; Included Free</span>';
          } else {
            gloveCard.classList.remove('is-unlocked');
            var rem2999 = 2999 - effectiveSubtotal;
            gloveBadge.innerHTML = '<span class="gift-badge-locked"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg> Add ' + moneyFormat(rem2999) + ' to unlock</span>';
          }
        }

        var matCard = formEl.querySelector('[data-gift-card="mat"]');
        var matBadge = formEl.querySelector('[data-gift-badge="mat"]');
        if (matCard && matBadge) {
          if (effectiveSubtotal >= 8000) {
            matCard.classList.add('is-unlocked');
            matBadge.innerHTML = '<span class="gift-badge-unlocked"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"/></svg> UNLOCKED &middot; Included Free</span>';
          } else {
            matCard.classList.remove('is-unlocked');
            var rem80 = 8000 - effectiveSubtotal;
            matBadge.innerHTML = '<span class="gift-badge-locked"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg> Add ' + moneyFormat(rem80) + ' to unlock</span>';
          }
        }

        var perkPrompt = formEl.querySelector('[data-perk-prompt]');
        if (perkPrompt) {
          if (effectiveSubtotal >= 8000) {
            perkPrompt.innerHTML = '<span>This order qualifies for <strong>Free AU Delivery &amp; Both Care Gifts ($139+ Value &middot; Limit 1 each)</strong> automatically in cart.</span>';
          } else if (effectiveSubtotal >= 2999) {
            var neededForMat = 8000 - effectiveSubtotal;
            perkPrompt.innerHTML = '<span>This order qualifies for <strong>Free AU Delivery &amp; Free Grooming Glove ($39.99 Value &middot; Limit 1)</strong>. Add ' + moneyFormat(neededForMat) + ' to unlock the Chenille Pet Mat ($99.99 Value)!</span>';
          } else {
            var neededForGlove = 2999 - effectiveSubtotal;
            perkPrompt.innerHTML = '<span>This order includes <strong>Free AU Delivery</strong>. Add ' + moneyFormat(neededForGlove) + ' more to unlock your complimentary Grooming Glove ($39.99 Value &middot; Limit 1)!</span>';
          }
        }

        var stickyText = document.querySelector('.sticky-buy span');
        if (stickyText) {
          if (effectiveSubtotal >= 8000) {
            stickyText.textContent = 'Free AU Delivery + Free Glove & Bath Mat Unlocked';
          } else if (effectiveSubtotal >= 2999) {
            stickyText.textContent = 'Free AU Delivery + Free Grooming Glove Unlocked';
          } else {
            stickyText.textContent = 'Free AU Delivery Included';
          }
        }
      }

      updateTierDisplay(v);

      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = moneyFormat(v.price);

      var stickyBtn = document.querySelector('[data-sticky-add]');
      if (stickyBtn) {
        stickyBtn.disabled = isSoldOut;
        stickyBtn.textContent = isSoldOut ? 'Sold out' : 'Add to cart';
      }

      if (v.featured_image && v.featured_image.src) {
        var filename = v.featured_image.src.split('?')[0].split('/').pop();
        var matchingThumb = null;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          var img = thumb.querySelector('img');
          if (img && img.src.indexOf(filename) !== -1) {
            matchingThumb = thumb;
          }
        });
        if (matchingThumb && typeof setActiveMedia === 'function') {
          var idx = parseInt(matchingThumb.getAttribute('data-index') || '0', 10);
          setActiveMedia(idx);
        }
      }
    }

    // Bundle Tier Cards click handler
    formEl.querySelectorAll('[data-tier-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var tier = parseInt(card.getAttribute('data-tier-card') || '1', 10);
        formEl.querySelectorAll('[data-tier-card]').forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (qtyInput) {
          qtyInput.value = tier;
        }
        updateUI();
      });
    });

    function syncTierCardsWithQty(val) {
      formEl.querySelectorAll('[data-tier-card]').forEach(function (c) {
        var cardTier = parseInt(c.getAttribute('data-tier-card') || '0', 10);
        var radio = c.querySelector('input[type="radio"]');
        if (cardTier === val) {
          c.classList.add('active');
          if (radio) radio.checked = true;
        } else {
          c.classList.remove('active');
          if (radio) radio.checked = false;
        }
      });
    }

    formEl.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      group.querySelectorAll('.swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('.swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          selected[idx] = btn.getAttribute('data-value');
          updateUI();
        });
      });
    });

    if (qtyInput) {
      var minus = formEl.querySelector('[data-qty-minus]');
      var plus = formEl.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        var nextVal = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        qtyInput.value = nextVal;
        syncTierCardsWithQty(nextVal);
        updateUI();
      });
      if (plus) plus.addEventListener('click', function () {
        var nextVal = Math.min(99, parseInt(qtyInput.value || '1', 10) + 1);
        qtyInput.value = nextVal;
        syncTierCardsWithQty(nextVal);
        updateUI();
      });
      qtyInput.addEventListener('change', function() {
        var val = parseInt(qtyInput.value || '1', 10);
        syncTierCardsWithQty(val);
        updateUI();
      });
    }

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput || !idInput.value) return;
      if (addBtn) { addBtn.disabled = true; }
      if (statusEl) { statusEl.textContent = 'Adding to cart…'; statusEl.dataset.state = ''; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: idInput.value,
          quantity: qtyInput ? parseInt(qtyInput.value || '1', 10) : 1
        })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            throw new Error(res.data && res.data.description ? res.data.description : 'Could not add this to your cart.');
          }
          if (statusEl) { statusEl.textContent = '✓ Added to your cart! Redirecting…'; statusEl.dataset.state = 'success'; }
          if (addBtn) { addBtn.textContent = '✓ Added to Cart!'; }
          refreshCartCount();
          setTimeout(function() {
            window.location.href = '/cart';
          }, 350);
        })
        .catch(function (err) {
          if (statusEl) { statusEl.textContent = err.message || 'Something went wrong — please try again.'; statusEl.dataset.state = 'error'; }
          updateUI();
        });
    });

    updateUI();
  });

  /* ---------- sticky mobile buy bar triggers the main form ---------- */
  document.querySelectorAll('[data-sticky-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var form = document.querySelector('[data-product-form]');
      if (form) {
        if (form.hasAttribute('data-sold-out')) return;
        btn.textContent = 'Adding to cart…';
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      }
    });
  });

  /* ---------- scroll reveal ---------- */
  var revealTargets = document.querySelectorAll('.reveal, .reveal-stagger');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('in'); });
  }
  requestAnimationFrame(function () {
    document.querySelectorAll('.hero .reveal, .hero .reveal-stagger').forEach(function (el) { el.classList.add('in'); });
  });

  /* ---------- countdown timer (announcement bar) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var display = el.querySelector('[data-countdown-display]');
    if (!display) return;
    var mode = el.getAttribute('data-mode');
    var deadline;

    if (mode === 'daily') {
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var storageKey = 'bmc_daily_countdown_deadline';
      var stored = null;
      try { stored = localStorage.getItem(storageKey); } catch (e) {}
      var now = Date.now();
      if (stored && parseInt(stored, 10) > now) {
        deadline = parseInt(stored, 10);
      } else {
        deadline = now + hours * 60 * 60 * 1000;
        try { localStorage.setItem(storageKey, String(deadline)); } catch (e) {}
      }
    } else {
      var endStr = el.getAttribute('data-end');
      if (!endStr) { el.hidden = true; return; }
      deadline = new Date(endStr).getTime();
      if (isNaN(deadline)) { el.hidden = true; return; }
    }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        if (mode === 'daily') {
          var hours2 = parseFloat(el.getAttribute('data-hours')) || 24;
          deadline = Date.now() + hours2 * 60 * 60 * 1000;
          try { localStorage.setItem('bmc_daily_countdown_deadline', String(deadline)); } catch (e) {}
        } else {
          el.hidden = true;
          clearInterval(interval);
          return;
        }
      }
      diff = Math.max(0, deadline - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      display.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    var interval = setInterval(tick, 1000);
  });

  /* ---------- bundle deal: add all items in one request ---------- */
  document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ids = (btn.getAttribute('data-products') || '').split(',').filter(Boolean).map(function (id) {
        return { id: id, quantity: 1 };
      });
      if (!ids.length) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Could not add the bundle to your cart.');
          btn.textContent = 'Added to cart ✓';
          refreshCartCount();
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2200);
        })
        .catch(function (err) {
          btn.textContent = err.message || 'Something went wrong';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2500);
        });
    });
  });

  /* ---------- welcome email popup ---------- */
  var popup = document.getElementById('welcomePopup');
  if (popup) {
    var popupDelay = parseInt(popup.getAttribute('data-delay-ms'), 10) || 10000;
    var dismissKey = 'bmc_welcome_popup_dismissed';
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('reset_popup') === '1' || urlParams.get('test_popup') === '1') {
      try { localStorage.removeItem(dismissKey); } catch (e) {}
    }
    var alreadyDismissed = false;
    try { alreadyDismissed = localStorage.getItem(dismissKey) === '1'; } catch (e) {}

    if (!alreadyDismissed) {
      setTimeout(function () {
        popup.hidden = false;
        document.body.classList.add('bmc-popup-open');
      }, popupDelay);
    }

    function closePopup() {
      popup.hidden = true;
      document.body.classList.remove('bmc-popup-open');
      try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });
    var popupForm = popup.querySelector('form');
    var formState = popup.querySelector('[data-popup-state-form]');
    var successState = popup.querySelector('[data-popup-state-success]');
    var emailInput = popup.querySelector('#WelcomePopupEmail');
    var userEmailEl = popup.querySelector('[data-popup-user-email]');
    var copyBtn = popup.querySelector('#welcomePopupCopyBtn');
    var applyBtn = popup.querySelector('#welcomePopupApplyBtn');
    var serverSuccess = popup.querySelector('[data-server-success]');

    function showSuccess(email) {
      if (formState) formState.style.display = 'none';
      if (successState) successState.style.display = 'block';
      if (userEmailEl && email) userEmailEl.textContent = email;
      try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
    }

    if (serverSuccess) {
      popup.hidden = false;
      document.body.classList.add('bmc-popup-open');
      showSuccess('your inbox');
    }

    if (popupForm) {
      popupForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = emailInput ? emailInput.value : '';
        var submitBtn = popup.querySelector('[data-popup-submit]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Generating your code…';
        }

        var formData = new FormData(popupForm);
        fetch(popupForm.action || window.location.href, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function() {
          showSuccess(email);
        }).catch(function() {
          showSuccess(email);
        });
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = 'WELCOME5';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = '✓ Copied!';
            setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
          });
        } else {
          copyBtn.textContent = '✓ Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
        }
      });
    }

    if (applyBtn) {
      applyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        applyBtn.textContent = 'Applying 5% Off…';
        fetch('/discount/WELCOME5').then(function() {
          closePopup();
          window.location.href = '/collections/all';
        }).catch(function() {
          window.location.href = '/discount/WELCOME5?redirect=/collections/all';
        });
      });
    }
  }
});
